import type React from "react";
import {useState} from "react";
import {useAuthState} from "react-firebase-hooks/auth";

import {useCreatePlaylist} from "~/api/hooks/useCreatePlaylist";
import CustomButton from "~/component/common/CustomButton";
import {auth} from "~/firebase/firebase";

import ButtonSpinner from "../../../../component/spinner/ButtonSpinner";

interface CreatePlaylistContentProps {
  closeModal: () => void;
}

const CreatePlaylistContent: React.FC<CreatePlaylistContentProps> = ({
  closeModal,
}) => {
  const [user] = useAuthState(auth);
  const [newPlaylistName, setNewPlaylistName] = useState("");

  // Use the new hook created with functionHookFactory.
  const {
    mutateAsync: createPlaylist,
    isPending: isCreating,
    reset,
  } = useCreatePlaylist();

  const handleCreate = () => {
    if (!user) return;
    createPlaylist({
      data: {
        name: newPlaylistName,
        levelIds: [],
      },
    }).then(() => {
      setNewPlaylistName("");
      closeModal();
      reset();
    });
  };

  return (
    <div className="w-full text-white">
      <h2 className="text-2xl mb-4">New Playlist</h2>
      <input
        type="text"
        value={newPlaylistName}
        onChange={(e) => setNewPlaylistName(e.target.value)}
        placeholder="Playlist Name"
        className="w-full mb-4 p-2 border rounded bg-white text-black"
      />
      <div className="flex justify-end mt-4">
        <CustomButton
          className={`bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded ${
            !newPlaylistName ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={handleCreate}
          disabled={!newPlaylistName || isCreating}
        >
          <ButtonSpinner isLoading={isCreating} />
          Create
        </CustomButton>
      </div>
    </div>
  );
};

export default CreatePlaylistContent;
